import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import React from "react";

const infraDetailsDialog = ({ open, onClose, selectedInfraData }) => {
  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: "700" }}>
              Fix Issue
            </Typography>
            <IconButton aria-label="close" onClick={() => onClose(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="h5" sx={{ fontWeight: "600", mb: "20px" }}>
            Entity Name
          </Typography>
          <Box
            sx={{
              padding: "10px 10px",
              border: "1px solid #C5C9CF",
              borderRadius: "5px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2">Description of the issue</Typography>
              <Chip
                label={selectedInfraData.Status}
                icon={
                  selectedInfraData.Status === "Pass" ? (
                    <CheckCircleOutlineIcon
                      sx={{ color: "#057F28 !important" }}
                      fontSize="small"
                    />
                  ) : (
                    <WarningAmberIcon
                      sx={{ color: "#C71414 !important" }}
                      fontSize="small"
                    />
                  )
                }
                sx={{
                  backgroundColor:
                    selectedInfraData.Status === "Pass" ? "#E8FBF3" : "#FEEBEB",
                  color:
                    selectedInfraData.Status === "Pass" ? "#057F28" : "#C71414",
                  marginLeft: "3px",
                }}
              />
            </Box>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: "700", my: "25px" }}>
              How would you like to fix
            </Typography>
            <Accordion sx={{ boxShadow: "unset" }}>
              <AccordionSummary sx={{ display: "flex", background: "#F1F3F9" }}>
                <Box
                  sx={{
                    background: "#F1F3F9",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  <Typography sx={{ fontWeight: "700" }}>
                    Generate Terraform code for the non-compliant resource.
                  </Typography>
                  <Typography variant="body2" sx={{ my: "8px" }}>
                    Generated by Regodit AI (Beta)
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ border: "1px solid #E4E4E4" }}>
                <Typography>
                  <pre>
                    <code>
                      {`resource "aws_s3_bucket" "example" {
                        bucket = "example-bucket"
                        server_side_encryption_configuration {
                        rule {
                        apply_server_side_encryption_by_default {
                        sse_algorithm = "AES256"
                        }
                        }
                        }`}
                    </code>
                  </pre>
                </Typography>
                <Box textAlign="end">
                  <Button variant="outlined" sx={{ fontWeight: "700" }}>
                    Copy
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Typography
              sx={{
                fontWeight: "700",
                padding: "15px",
                background: "#F1F3F9",
                borderRadius: "5px",
                margin: "20px 0px 25px 0px",
              }}
            >
              Follow step by step instruction using AWS console
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default infraDetailsDialog;
